<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'header.notify' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div class="pl-0">
    <div style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;">{{'messages.sso_notify' | translate}}
      <span class="text">{{'messages.sso_notify_1' | translate}}</span>{{'messages.sso_notify_2' | translate}}
    </div>
  </div>

  <div mat-dialog-actions class="justify-content-end">
  
    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial>
      {{'button.cancel_2' | translate}}
    </button>
    <button class="ml-4" mat-raised-button color="primary"  (click)="onConfirmClick()">
      {{'button.forward' | translate}}
    </button>
  </div>
  